import moment from "moment";
import classNames from "classnames";
import _, { get, isEmpty, omit } from "lodash";
import {
  NEW_ITEM,
  OVERHAULED,
  REPAIRED,
  REPAIR_AND_HOLD,
  OUT_ON_EXCHANGE,
  AT_SHOP,
  REPAIR_STATUS
} from "MODULES/inventories/constants";
import { ATL, BBTL, BTL, ZTL, SATL } from "MODULES/parts/constants";
import { properCase } from "LIB/formatters/text";
import { CUSTOM_RANGE } from "MODULES/SalesDashboard/constants";
import { CARRIERS } from "MODULES/shared/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";

export function warrantyForCondition(condition, part, tagDate, inventory) {
  const defaultCondition = useSettings()[`${condition}_warranty`] || null;
  if (
    [NEW_ITEM, REPAIRED, OVERHAULED].includes(condition) &&
    get(inventory, REPAIR_STATUS) !== REPAIR_AND_HOLD
  ) {
    const months = useSettings().tag_date_months_for_warranty || null;
    if (
      months &&
      tagDate &&
      moment(tagDate).isBefore(moment().subtract(Number(months), "month"))
    ) {
      return useSettings().tag_date_warranty;
    }
    // For a nil tagDate or one older than 2 years
    return defaultCondition;
  }

  return defaultCondition;
}

function toString(number) {
  if (!number) return "";
  return String(number);
}

export function setLeadTime(inv) {
  if (inv.repair_status === REPAIR_AND_HOLD) {
    return toString(inv.repair_and_hold_lead_time);
  } else if (inv.repair_status === AT_SHOP) {
    return toString(inv.repair_estimated_lead_time);
  } else if (inv.status === OUT_ON_EXCHANGE) {
    return "30";
  }
  return inv.status === "in_stock" ? "0" : null;
}

export function setTagDate(inv) {
  if (inv.status === OUT_ON_EXCHANGE) {
    return moment()
      .add(1, "month")
      .format("YYYY-MM-DD");
  }

  return inv.tag_date;
}

export function setTraceTo(inv) {
  if (inv.status === OUT_ON_EXCHANGE) {
    return "";
  }

  return inv.traced_to;
}

export function setTraceType(inv) {
  if (inv.status === OUT_ON_EXCHANGE) {
    return "";
  }

  return inv.trace_type;
}

export function correctSerialText(inventory) {
  return `Please reidentify Serial # ${inventory.serial_number}. The correct Serial # appears to be ${inventory.correct_serial_number}`;
}

export function getPartNumberColorClassNameByTierType(tierType) {
  return classNames({
    "text-light-purple": tierType === SATL,
    "text-green": tierType === ATL,
    "text-teal": tierType === ZTL,
    "text-yellow": tierType === BTL,
    "text-red": tierType === BBTL
  });
}

export const transformOQInputValues = lineItem =>
  Object.assign({}, lineItem, {
    offer: setOffer(lineItem),
    other: !isEmpty(lineItem.other_tag_type)
  });

export const transformOQOutputValues = lineItem =>
  Object.assign({}, omit(lineItem, ["offer"]), {
    no_interest: lineItem.offer === "no_interest",
    looking_for: lineItem.offer === "looking_for"
  });

export function setOffer(lineItem) {
  if (lineItem.no_interest) {
    return "no_interest";
  } else if (lineItem.looking_for) {
    return "looking_for";
  }
  return "";
}

export const arrayToOptions = array =>
  array.reduce(
    (acc, field) => ({
      ...acc,
      [field]: { label: properCase(field), value: field }
    }),
    {}
  );

export const hasCreditAndWarranty = (inv, path = "") =>
  _.get(inv, `${path}.credit_requested`) &&
  _.get(inv, `${path}.warranty_consideration`);

export const rmaIsClosed = (inv, path = "") =>
  _.get(inv, path) && _.get(inv, `${path}.closed_date`);

export const hasWarrantyAndNotCredit = (inv, path = "") =>
  !_.get(inv, `${path}.credit_requested`) &&
  _.get(inv, `${path}.warranty_consideration`);

export const getCreditRequestedWarrantyRmas = (lineItems, path = "") =>
  lineItems.filter(inv => hasCreditAndWarranty(inv, path));

export const getWarrantyAndNotCreditRmas = (lineItems, path = "") =>
  lineItems.filter(inv => hasWarrantyAndNotCredit(inv, path));

export function setDateLabel(startDate, endDate, label) {
  if (!startDate && !endDate) return null;
  return label === CUSTOM_RANGE || label === undefined
    ? `${moment(startDate).format("MMMM DD YYYY")} ` +
        `- ${moment(endDate).format("MMMM DD YYYY")}`
    : label;
}

export const getCarrierLabel = carrier => CARRIERS[carrier].label;

export const getShippingMethod = (carrier, shippingMethod) =>
  CARRIERS[carrier].shippingMethods[shippingMethod].label;



// WEBPACK FOOTER //
// ./app/modules/shared/helpers.js